import { Component, OnInit } from '@angular/core';
import { SessionStateService } from '../../../../core/services/session-state.service';

@Component({
  selector: 'app-coachmark-home',
  templateUrl: './coachmark-home.component.html',
  styleUrls: ['./coachmark-home.component.scss']
})
export class CoachmarkHomeComponent implements OnInit {
  selectedTab: number;
  show: boolean;
  constructor(private sessionStateService: SessionStateService) { }

  ngOnInit() {
    this.selectedTab = 1;
    const renderWait = setInterval(() => {
      const elem = document.getElementById('consBubbles');
      const size = document.getElementsByTagName('svg')[0];
      if (elem) {
        const elemPosition: ClientRect = elem.getBoundingClientRect();
        const bublePositionChange = setInterval(() => {
          if ($('#cellImg').length === 1) {
            $('#cellImg').css('left', elemPosition.left - (size.width.animVal.value / 3))
              .css('top', elemPosition.top - (size.height.animVal.value / 3))
              .css('display', 'block')
              .css('width', size.width.animVal.value * 1.35)
              .css('height', size.height.animVal.value * 1.35),

              clearInterval(bublePositionChange);
          }
          if ($('#options').length === 1) {
            $('#options').css('left', elemPosition.left + size.width.animVal.value + 80);

          }
        }, 200);
      clearInterval(renderWait);
      this.show = true;
    }
    }, 200);
  }

  getCellImg() {
    const lang = this.sessionStateService.getLang();
    switch (lang) {
      case 'ES':
        return '../assets/img/icons/coachmarks-home-es.svg';
      case 'PT':
        return '../assets/img/icons/coachmarks-home-pt.svg';
      case 'EN':
        return '../assets/img/icons/coachmarks-home-en.svg';
      default:
        return '../assets/img/icons/coachmarks-home-pt.svg';
    }
  }


  skipHelpTips() {
    this.show = false;
    this.sessionStateService.setCoachMarkIndividualState(this.sessionStateService.getCoachMarkIndividualState().set('home', false));
  }

  nextTab() {
    if (this.selectedTab === 2) {
      const changeHouseMenu: HTMLElement = document.getElementById('navbarUserDropdown') as HTMLElement;
      if (changeHouseMenu) {
        changeHouseMenu.setAttribute('aria-expanded', 'false');
        changeHouseMenu.parentElement.lastElementChild.classList.remove('show');
        changeHouseMenu.parentElement.classList.remove('show');
      }
      if (window.innerWidth < 1367) {
        if ($('#toogleIcon').length === 1) {
          $('#toogleIcon')[0].click();
        }
      }
      this.skipHelpTips();
    } else {
      if ($('#coachmarkBackground').length === 1) {
        if (window.innerWidth < 1367) {
          if ($('#toogleIcon').length === 1) {
            $('#toogleIcon')[0].click();
          }
          $('#coachmarkBackground').css('left', 242);
        } else {
          if (window.innerWidth <= 1460 && window.innerWidth >= 1367 ) {
            $('#coachmarkBackground').css('left', 312);
          } else  {
            $('#coachmarkBackground').css('left', 332);
          }
        }
      }
      const changeHouseMenu: HTMLElement = document.getElementById('navbarUserDropdown') as HTMLElement;
      changeHouseMenu.setAttribute('aria-expanded', 'true');
      changeHouseMenu.parentElement.lastElementChild.classList.add('show');
      changeHouseMenu.parentElement.classList.add('show');
      this.selectedTab++;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/coachmarks/coachmark-home/coachmark-home.component.ts